import type { Selection } from './useTableSelection';
import { SelectionType } from './useTableSelection';

export interface CellBorders {
  inRange: boolean;
  leftBorder: boolean;
  rightBorder: boolean;
  topBorder: boolean;
  bottomBorder: boolean;
}

const getCellBordersForSelection = (
  selection: Selection | null,
  {
    rowIndex,
    columnIndex,
    rowCount,
    columnCount,
  }: {
    rowIndex: number;
    columnIndex: number;
    rowCount: number;
    columnCount: number;
  },
): CellBorders => {
  const isLastRow = rowIndex === rowCount - 1;
  const isLastColumn = columnIndex === columnCount - 1;
  switch (selection?.type) {
    case SelectionType.Row: {
      const { rows } = selection;
      const isInRange = rows.includes(rowIndex);
      return {
        inRange: isInRange,
        leftBorder: isInRange && columnIndex === 0,
        rightBorder: isInRange && isLastColumn,
        topBorder:
          isInRange && (rowIndex === 0 || !rows.includes(rowIndex - 1)),
        bottomBorder: isInRange && (isLastRow || !rows.includes(rowIndex + 1)),
      };
    }

    case SelectionType.Column: {
      const { columns } = selection;
      const isInRange = columns.includes(columnIndex);
      return {
        inRange: isInRange,
        topBorder: isInRange && rowIndex === 0,
        bottomBorder: isInRange && isLastRow,
        leftBorder:
          isInRange &&
          (columnIndex === 0 || !columns.includes(columnIndex - 1)),
        rightBorder:
          isInRange && (isLastColumn || !columns.includes(columnIndex + 1)),
      };
    }

    case SelectionType.Table: {
      return {
        inRange: true,
        leftBorder: columnIndex === 0,
        rightBorder: isLastColumn,
        topBorder: rowIndex === 0,
        bottomBorder: isLastRow,
      };
    }

    default:
      return {
        inRange: false,
        leftBorder: false,
        rightBorder: false,
        topBorder: false,
        bottomBorder: false,
      };
  }
};

export default getCellBordersForSelection;
